import { FullJoints, ViewTypes, ViewTypeData, ExamTypes } from "models/XrayModels";

export type ReqViewsByJointType = {
  [FJ in FullJoints]: {
    [VT in ViewTypes]?: ViewTypeData<VT>;
  };
};

export type ReqViewsByExamType = {
  [ET in ExamTypes]: {
    [VT in ViewTypes]?: ViewTypeData<VT>;
  };
};


type FullJointsByExamTypesType = {
  [ET in ExamTypes]: {
    [FJ in FullJoints | string]?: FullJoints | string;
  };
};

// this object is used to confirm which FullJoint values are present in a given exam type. it is
// used on the Appointment Overview Page as well as by the getMissingXraysByActiveExams helper function
export const fullJointsByExamTypes: FullJointsByExamTypesType = {
  [ExamTypes.SINGLE_KNEE_RIGHT]: {
    [FullJoints.RIGHT_KNEE]: FullJoints.RIGHT_KNEE,
    'bilateral knee': 'bilateral knee',
  },
  [ExamTypes.SINGLE_KNEE_LEFT]: {
    [FullJoints.LEFT_KNEE]: FullJoints.LEFT_KNEE,
    'bilateral knee': 'bilateral knee',
  },
  [ExamTypes.BILAT_KNEE]: {
    [FullJoints.RIGHT_KNEE]: FullJoints.RIGHT_KNEE,
    [FullJoints.LEFT_KNEE]: FullJoints.LEFT_KNEE,
    'bilateral knee': 'bilateral knee',
  },
  [ExamTypes.SINGLE_HIP_RIGHT]: {
    [FullJoints.RIGHT_HIP]: FullJoints.RIGHT_HIP,
    'bilateral hip': 'bilateral hip',
  },
  [ExamTypes.SINGLE_HIP_LEFT]: {
    [FullJoints.LEFT_HIP]: FullJoints.LEFT_HIP,
    'bilateral hip': 'bilateral hip',
  },
  [ExamTypes.BILAT_HIP]: {
    [FullJoints.RIGHT_HIP]: FullJoints.RIGHT_HIP,
    [FullJoints.LEFT_HIP]: FullJoints.LEFT_HIP,
    'bilateral hip': 'bilateral hip',
  },
};

export enum ViewTypeValues {
  // view types that need joint or other label
  AP_KNEE = 'ap_knee',
  UNILATERAL_KNEECAP = 'unilateral_kneecap',
  LATERAL_KNEE = 'lateral_knee',

  // view types that don't need extra annotation
  BILATERAL_KNEE = 'bilateral_knee',
  BILATERAL_KNEECAP = 'bilateral_kneecap',
  AP_PELVIS = 'ap_pelvis',
  LEFT_FROG = 'left_frog',
  RIGHT_FROG = 'right_frog',
}